import { useLocation } from "@tanstack/react-router";
import { useEffect } from "react";

import { trackPageView } from "../libs/analytics";

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view when route changes
    trackPageView(location.pathname, document.title);
  }, [location.pathname]);
};
